import config from '@/config'
export default ($axios) => {
  return {
    /**
     * 用户详情
     */
    getUserInfo() {
      const data = {
        action: '/main/get-self-info'
      }
      return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
    },

    getOssParam(type) {
      const data = {
        type: type,
        action: '/main/get-oss-param'
      }
      return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
    },
    checkPhone(phone) {
      const data = {
        phone: phone,
        action: '/main/check-phone'
      }
      return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
    },
    getIndex() {
      const data = {
        action: '/main/get-index'
      }
      return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
    },
    uploadPic(type) {
      const data = {
        type: type,
        action: '/common/upload-pic'
      }
      return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
    },
     getRouter() {
      const data = {
        action: '/main/get-router'
      }
      return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
    },
  }


}
